// extracted by mini-css-extract-plugin
module.exports = {"container":"PartnerSection_container__3Xqpt","wrapper":"PartnerSection_wrapper__1M6my"};